import React, { useEffect, useState } from 'react'
import { PrismicRichText } from '@prismicio/react'
import { sliceBottomPadding } from '../../util/helper'
import * as Styled from './styles/TableBlock.styles'

const TableBlock = ({ data }) => {
  const [tableContent, setTableContent] = useState(null)
  const [tableTitle, setTableTitle] = useState(null)
  const [columnIndices, setColumnIndices] = useState([])

  useEffect(() => {
    if (!data || !data?.items) return

    setTableTitle(data.primary?.table_title?.text ?? null)
    setTableContent(data.items)

    // Determine the indices of populated columns
    const columns = data.items.reduce(
      (acc, item) => {
        if (item.column_1_content?.richText?.length > 0) acc[0] = true
        if (item.column_2_content?.richText?.length > 0) acc[1] = true
        if (item.column_3_content?.richText?.length > 0) acc[2] = true
        return acc
      },
      [false, false, false]
    )

    const populatedIndices = columns
      .map((isPopulated, index) => (isPopulated ? index : null))
      .filter(index => index !== null)
    setColumnIndices(populatedIndices)
  }, [data])

  return (
    <Styled.TableBlock
      bottomPaddingAdjustment={sliceBottomPadding(
        data.primary?.bottom_padding_adjustment
      )}
    >
      {tableTitle && <Styled.TableTitle>{tableTitle}</Styled.TableTitle>}
      {tableContent && (
        <Styled.Table>
          <colgroup>
            {columnIndices.map((_, index) => (
              <col key={index} style={{ width: 'auto' }} />
            ))}
          </colgroup>
          <tbody>
            {tableContent.map((item, rowIndex) => (
              <Styled.TableRow key={rowIndex}>
                {columnIndices.includes(0) && (
                  <Styled.TableCell>
                    {item.column_1_content?.richText && (
                      <PrismicRichText field={item.column_1_content.richText} />
                    )}
                  </Styled.TableCell>
                )}
                {columnIndices.includes(1) && (
                  <Styled.TableCell>
                    {item.column_2_content?.richText && (
                      <PrismicRichText field={item.column_2_content.richText} />
                    )}
                  </Styled.TableCell>
                )}
                {columnIndices.includes(2) && (
                  <Styled.TableCell>
                    {item.column_3_content?.richText && (
                      <PrismicRichText field={item.column_3_content.richText} />
                    )}
                  </Styled.TableCell>
                )}
              </Styled.TableRow>
            ))}
          </tbody>
        </Styled.Table>
      )}
    </Styled.TableBlock>
  )
}

export default TableBlock
